import { PAGINATION, PAGE, TOTAL, LIMIT } from "../_types/paginationType";

export const onChangePage = (page) => async (dispatch) => {
  dispatch({ type: PAGE, payload: page });
};
